import { Checkbox } from '@base-ui/react/checkbox';
import { Icon } from '@components/icon/Icon';
import styles from './OccupantSelectionCheckbox.scss';

export const OccupantSelectionCheckbox = ({
  id,
  checked,
  label,
  onChange,
}: {
  id: string;
  checked: boolean;
  label?: string;
  onChange: () => void;
}) => {
  const identifier = `multi-selection-checkbox-${id}`;
  const ariaLabel = label
    ? `Selector for ${label}`
    : `Selector for occupant ${id}`;

  return (
    <label htmlFor={identifier}>
      <Checkbox.Root
        aria-label={ariaLabel}
        id={identifier}
        checked={checked}
        onCheckedChange={onChange}
        className={styles.checkbox}
      >
        <Checkbox.Indicator className={styles.indicator}>
          <Icon name="checkMark" className={styles.icon} />
        </Checkbox.Indicator>
      </Checkbox.Root>
    </label>
  );
};
